import { RequestFailure } from '@owl-nest/api-client'
import * as model from '@owl-nest/models'
import { Status } from '@owl-nest/redux-wrapper'

import { TYPE, Action } from '../actions/impact'

export type State = {
  data?: model.impact.Impact
  status: {
    load:
      | { status: Status.PENDING; projectId: number }
      | { status: Status.PRISTINE }
      | { status: Status.SUCCESS }
      | { status: Status.FAILURE; failure: RequestFailure }
  }
}

export const initialState: State = {
  status: {
    load: { status: Status.PRISTINE },
  },
}

export function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case TYPE.LOAD_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: { status: Status.PENDING, projectId: action.projectId },
        },
      }
    }

    case TYPE.LOAD_FAILURE: {
      return {
        ...state,
        data: undefined,
        status: {
          ...state.status,
          load: { status: Status.FAILURE, failure: action.failure },
        },
      }
    }

    case TYPE.LOAD_SUCCESS: {
      return {
        ...state,
        data: action.success,
        status: {
          ...state.status,
          load: { status: Status.SUCCESS },
        },
      }
    }

    case TYPE.SET: {
      return {
        ...state,
        data: action.impact,
        status: {
          ...state.status,
          load: { status: Status.SUCCESS },
        },
      }
    }

    default:
      return state
  }
}
